import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './services/auth.service';
// import { Observable } from 'rxjs/Observable';

@Injectable()

export class AuthGuard implements CanActivate {
  private isLoggedIn: boolean;
  constructor(
    private authService: AuthService){}

  canActivate(){
   this.authService.isLoggedIn.subscribe(e => {
      if(e != null) {
        this.isLoggedIn = e;
      } else {
        this.isLoggedIn = false;
      }
    });

    if(this.isLoggedIn){
      // console.log('logged in!');
      if(this.authService.userLoginType){
        return true;
      }
      return false;
    } else {
      // console.log('not logged in!');
      // this.router.navigate(['/'], {skipLocationChange: true});
      this.authService.login();
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/shared/auth.guard.ts